import { infoWindow } from "./info-window";

function markerClick(map, marker) {
  marker.addListener("click", function() {
    infoWindow(map, this.customInfo);
  });
}

module.exports = {
  markerClick
};



// WEBPACK FOOTER //
// ../assets/js/map/marker-events.js